import { createDateRange } from '../../utils/dateUtils'

export const createQueryFilter = (filter) => {
  if (!filter) return undefined
  const queryfilter = {}

  // Add source parameter for archived data search
  if (filter.searchArchived) {
    queryfilter.source = 'archived'
  }

  if (filter.mainPaxName)
    queryfilter.mainPaxName_like = filter.mainPaxName

  if (filter.confirmationNumber)
    queryfilter.confirmationNumber_like = filter.confirmationNumber

  if (filter.flightNumber)
    queryfilter.flightNumber_like = filter.flightNumber

  if (filter.serviceDateTimeStart) {
    // Use timezone-aware date range for start date
    const startDateRange = createDateRange(filter.serviceDateTimeStart)
    queryfilter.serviceDateTime_gte = startDateRange.start
  }

  if (filter.serviceDateTimeEnd) {
    // Use timezone-aware date range for end date
    const endDateRange = createDateRange(filter.serviceDateTimeEnd)
    queryfilter.serviceDateTime_lte = endDateRange.end
  }

  if (filter.status) queryfilter.status = filter.status

  if (filter.jobAssignStatus)
    queryfilter.jobAssignStatus = filter.jobAssignStatus

  if (filter.productId) queryfilter.productId = filter.productId

  if (filter.agentId) queryfilter.agentId = filter.agentId

  if (filter.stationId) queryfilter.stationId = filter.stationId

  return queryfilter
}
